import { api, fetchServer } from "@/features/utils/fetch-server";
import type { VoiceBackground } from "../types";

export class VoiceBackgroundsAPI {
  static async list(
    clientId: string,
  ): Promise<{ backgrounds: VoiceBackground[] }> {
    return api.get(`/api/configuration/v1/${clientId}/voice-backgrounds`);
  }

  /** `fetchServer` rather than `api.post` — this is multipart, not JSON. */
  static async upload(
    clientId: string,
    file: File,
    name: string,
  ): Promise<{ background: VoiceBackground }> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);

    const response = await fetchServer(
      `/api/configuration/v1/${clientId}/voice-backgrounds/upload`,
      {
        method: "POST",
        body: formData,
      },
    );
    return response.json();
  }
}
